import * as React from 'react';
import { IEventSearchResultHitDTO } from '../../DTO/search';
import * as moment from 'moment'
import { Fragment } from 'react';
import { IContentProps } from '../../models/content-props';
import { isNull } from 'lodash';

interface IProps {
    result: IEventSearchResultHitDTO;
    onClick: (hitId: string) => void;
    contentProps: IContentProps;
    isArchived: boolean;
    isFeatured: boolean;
}

export function EventResult({ result, onClick, contentProps, isArchived, isFeatured }: IProps) {
    const renderCategory = (category: string, index: number) => {
        return (<span key={category + '-' + index} className="adage-search-results-item-category">{category}</span>);
    };

    const hitOnClick = () => onClick(result.hitId);

    const CreditsText = result.eventCreditsEarned == 1 ? "Credit" : "Credits";
    const FullCreditsText = result.nasbaAccredited ? `NACD/CPE ${CreditsText}` : `NACD ${CreditsText}`;

    const eventStartDate = moment(result.eventStartDateTime).format('MMMM D, yyyy');
    const eventEndDate = moment(result.eventEndDateTime).format('MMMM D, yyyy');

    return (
        <li className={"adage-search-results-item " + (result.isBestBet ? "best-bet " : "") + (isFeatured && !isArchived ? "adage-search-featured-item " : "") + (isArchived ? "adage-search-archived-item " : "")}>
            <div className='item-content'>
                {/* Event title */}
                <h2 className='h4-style'>
                    <a href={result.url} onClick={hitOnClick} dangerouslySetInnerHTML={{ __html: result.title }}></a>
                </h2>

                {/* Event details */}
                {isArchived ?
                    <p className='item-details'>
                        <span>Archive Event</span>
                        {eventStartDate != eventEndDate ?
                            <span>{moment(result.eventStartDateTime).format('MMMM D')} - {moment(result.eventEndDateTime).format('MMMM D, yyyy')}</span>
                            :
                            <span>{moment(result.eventStartDateTime).format('MMMM D, yyyy')} {result.timeZone} </span>
                        }
                    </p>
                    :
                    <p className='item-details'>
                        {!result.isSelectedOnDemand && 
                            <>
                                {eventStartDate != eventEndDate ?
                                    <span>{moment(result.eventStartDateTime).format('MMMM D')} - {moment(result.eventEndDateTime).format('MMMM D, yyyy')}</span>
                                    :
                                    <span>{moment(result.eventStartDateTime).format('MMMM D, yyyy')}</span>
                                }
                                <span>{moment(result.eventStartDateTime).format('hh:mm A')} - {moment(result.eventEndDateTime).format('hh:mm A')} {result.timeZone} </span>
                            </>
                        }                            
                        
                        {result.eventCreditsEarned > 0 &&
                            <span>
                                {result.eventCreditsEarned} {FullCreditsText}
                            </span>
                        }
                    </p>
                }

                {/* Event description */}
                {result.description &&
                    <div className='item-description' dangerouslySetInnerHTML={{ __html: result.description }}></div>
                }

                {/* Event pricing */}
                {(!isArchived && !result.controlToHidePrice) &&
                    <div className="item-pricing">
                        <p>{`Member Price: ${result.memberPrice}`} 
                            { (result.nonMemberPrice != "") && 
                            ` | Non Member Price: ${result.nonMemberPrice}`}</p>
                    </div>                 
                }
                {(!isArchived && result.controlToHidePrice) &&
                    <div className="item-pricing">
                        <p>{result.goToDetailForPricing}</p>
                    </div>
                }

                {/* Event categories */}
                {
                    <div className="adage-search-results-item-categories">
                        {result.eventFormat &&
                            renderCategory(result.eventFormat, 1)}
                        {result.eventCityAndState &&
                            renderCategory(result.eventCityAndState, 2)}
                        {result.eventOrganizer &&
                            renderCategory(result.eventOrganizer, 3)}
                    </div>
                }

                {/* Event register button */}
                {(!isArchived && !isNull(result.registerUrl)) &&
                    <a href={result.registerUrl} target={`${result.registrationLinkTargetFrame}`} className={result.isFeatured ? 'btn-secondary' : 'btn-primary'} dangerouslySetInnerHTML={{ __html: result.registrationLinkLabel }}></a>
                }
                {/*Learn more button */}
                {(result.learnMoreButton && result.learnMoreButton.trim()) &&
                    <a href={result.url} className='btn-secondary'>{result.learnMoreButton}</a>
                }
            </div>

            {/* Event image */}
            {result.eventImage &&
                <div className='item-image'>
                    <div className='item-image-inner'>
                        <a href={result.url} onClick={hitOnClick}>
                            <img src={result.eventImage} />
                        </a>
                    </div>
                </div>
            }
        </li>
    );
};
